/**
 * AmcSelect — custom select for aogen forms (P3).
 * Auto-enhances selects inside .aogen-forms-form / .aogen-forms-block form.
 * Opt-out: data-amc-select="off" | .event-form-phone__select | inside .event-form-phone
 */
(function () {
  var OPEN_ROOT = null;
  var IGNORE_OUTSIDE_UNTIL = 0;
  var TYPEAHEAD = { buf: '', timer: null };
  var CHEVRON =
    '<svg class="amc-select__chevron" viewBox="0 0 12 8" width="12" height="8" aria-hidden="true" focusable="false"><path d="M1 1.5L6 6.5L11 1.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK =
    '<svg class="amc-select__check" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false"><path d="M3.5 8.5L6.5 11.5L12.5 4.5" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function rootsIn(doc) {
    return (doc || document).querySelectorAll('.aogen-forms-form, .aogen-forms-block form');
  }

  function shouldSkip(select) {
    if (!select || select.tagName !== 'SELECT') return true;
    if (select.getAttribute('data-amc-select') === 'off') return true;
    if (select.classList.contains('event-form-phone__select')) return true;
    if (select.closest('.event-form-phone')) return true;
    if (select.closest('.event-form-phone__country-wrap')) return true;
    return false;
  }

  function eventEl(e) {
    var t = e && e.target;
    if (!t) return null;
    if (t.nodeType !== 1) t = t.parentElement;
    return t;
  }

  function destroy(select) {
    if (!select) return;
    var wrap = select._amcSelectRoot;
    if (!wrap && select.nextElementSibling && select.nextElementSibling.getAttribute('data-amc-select-root') === '1') {
      wrap = select.nextElementSibling;
    }
    if (wrap && wrap._amcSelectMo) {
      try {
        wrap._amcSelectMo.disconnect();
      } catch (e) {}
    }
    if (wrap && wrap._amcSelectList && wrap._amcSelectList.parentNode) {
      wrap._amcSelectList.parentNode.removeChild(wrap._amcSelectList);
    }
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    select.classList.remove('amc-select-native');
    select.removeAttribute('data-amc-select-ready');
    select.removeAttribute('tabindex');
    select._amcSelectRoot = null;
    if (OPEN_ROOT === wrap) OPEN_ROOT = null;
  }

  function closeOpen() {
    if (!OPEN_ROOT) return;
    setOpen(OPEN_ROOT, false);
    OPEN_ROOT = null;
  }

  function positionList(root, list) {
    var trigger = root.querySelector('.amc-select__trigger');
    if (!trigger) return;
    var tr = trigger.getBoundingClientRect();
    var maxH = 240;
    var gap = 4;
    var spaceBelow = window.innerHeight - tr.bottom - gap;
    var spaceAbove = tr.top - gap;
    var flip = spaceBelow < 140 && spaceAbove > spaceBelow;
    var avail = Math.max(120, flip ? spaceAbove : spaceBelow);
    list.style.position = 'fixed';
    list.style.left = Math.max(8, tr.left) + 'px';
    list.style.width = Math.max(120, tr.width) + 'px';
    list.style.right = 'auto';
    list.style.zIndex = '10050';
    list.style.maxHeight = Math.min(maxH, avail) + 'px';
    if (flip) {
      list.style.top = 'auto';
      list.style.bottom = window.innerHeight - tr.top + gap + 'px';
      root.classList.add('is-flip');
    } else {
      list.style.bottom = 'auto';
      list.style.top = tr.bottom + gap + 'px';
      root.classList.remove('is-flip');
    }
  }

  function setOpen(root, open) {
    var list = root._amcSelectList || root.querySelector('.amc-select__list');
    var trigger = root.querySelector('.amc-select__trigger');
    if (!list || !trigger) return;
    root.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (list.parentNode !== document.body) {
        document.body.appendChild(list);
      }
      list.hidden = false;
      list.classList.add('amc-select__list--portal');
      positionList(root, list);
      syncActiveFromSelected(root, list);
      OPEN_ROOT = root;
    } else {
      list.hidden = true;
      list.classList.remove('amc-select__list--portal');
      root.classList.remove('is-flip');
      if (list.parentNode === document.body && root.isConnected) {
        root.appendChild(list);
      }
      if (OPEN_ROOT === root) OPEN_ROOT = null;
    }
  }

  function optionNodes(select) {
    return Array.prototype.slice.call(select.options || []);
  }

  function selectedOption(select) {
    var i = select.selectedIndex;
    if (i < 0) return null;
    return select.options[i] || null;
  }

  function syncTrigger(root, select) {
    var valueEl = root.querySelector('.amc-select__value');
    if (!valueEl) return;
    var opt = selectedOption(select);
    var text = opt ? String(opt.textContent || '').trim() : '';
    var empty = !opt || opt.value === '' || text === '' || text === '—' || text === 'Select an option';
    valueEl.textContent = empty
      ? select.getAttribute('data-amc-select-placeholder') || 'Select an option'
      : text;
    valueEl.classList.toggle('is-placeholder', empty);
  }

  function buildList(root, select, list) {
    list = list || root._amcSelectList || root.querySelector('.amc-select__list');
    if (!list) return;
    list.innerHTML = '';
    var children = select.children;
    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.tagName === 'OPTGROUP') {
        var g = document.createElement('li');
        g.className = 'amc-select__group';
        g.setAttribute('role', 'presentation');
        g.textContent = node.label || '';
        list.appendChild(g);
        Array.prototype.forEach.call(node.children, function (opt) {
          list.appendChild(makeOptionLi(opt));
        });
      } else if (node.tagName === 'OPTION') {
        list.appendChild(makeOptionLi(node));
      }
    }
  }

  function makeOptionLi(opt) {
    var li = document.createElement('li');
    li.className = 'amc-select__option';
    li.setAttribute('role', 'option');
    li.setAttribute('data-value', opt.value);
    li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
    if (opt.disabled) li.setAttribute('aria-disabled', 'true');
    var label = document.createElement('span');
    label.textContent = String(opt.textContent || '').trim();
    li.appendChild(label);
    li.insertAdjacentHTML('beforeend', CHECK);
    return li;
  }

  function syncActiveFromSelected(root, list) {
    list = list || root._amcSelectList || root.querySelector('.amc-select__list');
    if (!list) return;
    var opts = list.querySelectorAll('.amc-select__option:not([aria-disabled="true"])');
    var selected = list.querySelector('.amc-select__option[aria-selected="true"]');
    opts.forEach(function (el) {
      el.classList.remove('is-active');
    });
    if (selected) {
      selected.classList.add('is-active');
      if (selected.scrollIntoView) selected.scrollIntoView({ block: 'nearest' });
    }
  }

  function commitValue(root, select, value) {
    var prev = select.value;
    select.value = value;
    optionNodes(select).forEach(function (opt) {
      opt.selected = opt.value === value;
    });
    buildList(root, select);
    syncTrigger(root, select);
    setOpen(root, false);
    if (prev !== select.value) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function moveActive(root, delta) {
    var list = root._amcSelectList || root.querySelector('.amc-select__list');
    if (!list) return;
    var opts = Array.prototype.slice.call(
      list.querySelectorAll('.amc-select__option:not([aria-disabled="true"])')
    );
    if (!opts.length) return;
    var idx = opts.findIndex(function (el) {
      return el.classList.contains('is-active');
    });
    if (idx < 0) {
      idx = opts.findIndex(function (el) {
        return el.getAttribute('aria-selected') === 'true';
      });
    }
    var next = idx < 0 ? 0 : (idx + delta + opts.length) % opts.length;
    opts.forEach(function (el) {
      el.classList.remove('is-active');
    });
    opts[next].classList.add('is-active');
    if (opts[next].scrollIntoView) opts[next].scrollIntoView({ block: 'nearest' });
  }

  function typeahead(root, select, key) {
    if (!key || key.length !== 1) return;
    clearTimeout(TYPEAHEAD.timer);
    TYPEAHEAD.buf += key.toLowerCase();
    TYPEAHEAD.timer = setTimeout(function () {
      TYPEAHEAD.buf = '';
    }, 700);
    var opts = optionNodes(select).filter(function (o) {
      return !o.disabled;
    });
    var hit = opts.find(function (o) {
      return (
        String(o.textContent || '')
          .trim()
          .toLowerCase()
          .indexOf(TYPEAHEAD.buf) === 0
      );
    });
    if (!hit) return;
    var list = root._amcSelectList || root.querySelector('.amc-select__list');
    if (!list || list.hidden) {
      commitValue(root, select, hit.value);
      return;
    }
    list.querySelectorAll('.amc-select__option').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-value') === hit.value);
    });
  }

  function enhance(select) {
    if (shouldSkip(select)) {
      if (select && select.getAttribute('data-amc-select-ready') === '1') destroy(select);
      return null;
    }
    if (select.getAttribute('data-amc-select-ready') === '1') {
      return select._amcSelectRoot || null;
    }

    var wrap = document.createElement('div');
    wrap.className = 'amc-select';
    wrap.setAttribute('data-amc-select-root', '1');

    var id = select.id || 'amc-select-' + Math.random().toString(36).slice(2, 9);
    if (!select.id) select.id = id + '-native';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'amc-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.id = id + '-trigger';
    trigger.disabled = !!select.disabled;

    var valueEl = document.createElement('span');
    valueEl.className = 'amc-select__value is-placeholder';
    trigger.appendChild(valueEl);
    trigger.insertAdjacentHTML('beforeend', CHEVRON);

    var list = document.createElement('ul');
    list.className = 'amc-select__list';
    list.id = id + '-list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    trigger.setAttribute('aria-controls', list.id);
    wrap._amcSelectList = list;

    var label = select.closest('label, .wbw-lb__field');
    if (label) {
      var labelSpan = label.querySelector(':scope > span');
      if (labelSpan && labelSpan.parentNode === label) {
        if (!labelSpan.id) labelSpan.id = id + '-label';
        trigger.setAttribute('aria-labelledby', labelSpan.id);
      }
    }

    select.classList.add('amc-select-native');
    select.setAttribute('data-amc-select-ready', '1');
    select.setAttribute('tabindex', '-1');
    select._amcSelectRoot = wrap;

    /* Keep trigger outside <label> so label activation cannot eat option/trigger clicks.
       Lightbox fields (.wbw-lb__field) keep the control inside the field column. */
    var fieldHost = select.closest('.wbw-lb__field');
    var labelEl = select.closest('label');
    if (fieldHost) {
      select.parentNode.insertBefore(wrap, select.nextSibling);
    } else if (labelEl && labelEl.contains(select) && labelEl.parentNode) {
      labelEl.parentNode.insertBefore(wrap, labelEl.nextSibling);
    } else {
      select.parentNode.insertBefore(wrap, select.nextSibling);
    }
    wrap.appendChild(trigger);
    wrap.appendChild(list);

    buildList(wrap, select, list);
    syncTrigger(wrap, select);

    function toggleOpen(e) {
      e.preventDefault();
      e.stopPropagation();
      if (select.disabled) return;
      IGNORE_OUTSIDE_UNTIL = Date.now() + 250;
      var willOpen = !wrap.classList.contains('is-open');
      if (OPEN_ROOT && OPEN_ROOT !== wrap) closeOpen();
      setOpen(wrap, willOpen);
    }
    trigger.addEventListener('click', toggleOpen);

    function onPick(e) {
      var el = eventEl(e);
      var li = el && el.closest ? el.closest('.amc-select__option') : null;
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      e.stopPropagation();
      IGNORE_OUTSIDE_UNTIL = Date.now() + 250;
      commitValue(wrap, select, li.getAttribute('data-value'));
      trigger.focus();
    }
    list.addEventListener('click', onPick, true);

    trigger.addEventListener('keydown', function (e) {
      var open = wrap.classList.contains('is-open');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!open) setOpen(wrap, true);
        moveActive(wrap, e.key === 'ArrowDown' ? 1 : -1);
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!open) {
          setOpen(wrap, true);
          return;
        }
        var active = list.querySelector('.amc-select__option.is-active');
        if (active && active.getAttribute('aria-disabled') !== 'true') {
          commitValue(wrap, select, active.getAttribute('data-value'));
        } else {
          setOpen(wrap, false);
        }
        return;
      }
      if (e.key === 'Escape') {
        if (open) {
          e.preventDefault();
          setOpen(wrap, false);
        }
        return;
      }
      if (e.key === 'Tab') {
        setOpen(wrap, false);
        return;
      }
      if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
        typeahead(wrap, select, e.key);
      }
    });

    select.addEventListener('focus', function () {
      trigger.focus();
    });

    select.addEventListener('change', function () {
      buildList(wrap, select, list);
      syncTrigger(wrap, select);
      trigger.disabled = !!select.disabled;
    });

    var mo = new MutationObserver(function () {
      if (shouldSkip(select)) {
        destroy(select);
        return;
      }
      buildList(wrap, select, list);
      syncTrigger(wrap, select);
      trigger.disabled = !!select.disabled;
    });
    mo.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    wrap._amcSelectMo = mo;

    return wrap;
  }

  function enhanceRoot(root) {
    if (!root) return;
    root.querySelectorAll('select').forEach(function (sel) {
      if (shouldSkip(sel)) {
        if (sel.getAttribute('data-amc-select-ready') === '1') destroy(sel);
        return;
      }
      enhance(sel);
    });
  }

  function scanDocument() {
    rootsIn(document).forEach(enhanceRoot);
    document.querySelectorAll('select.event-form-phone__select[data-amc-select-ready="1"]').forEach(destroy);
  }

  function boot() {
    scanDocument();
    if (document.documentElement.getAttribute('data-amc-select-doc') === '1') return;
    document.documentElement.setAttribute('data-amc-select-doc', '1');

    document.addEventListener(
      'pointerdown',
      function (e) {
        if (!OPEN_ROOT) return;
        if (Date.now() < IGNORE_OUTSIDE_UNTIL) return;
        var el = eventEl(e);
        var list = OPEN_ROOT._amcSelectList;
        if (el && OPEN_ROOT.contains(el)) return;
        if (el && list && list.contains(el)) return;
        closeOpen();
      },
      true
    );

    window.addEventListener(
      'resize',
      function () {
        if (!OPEN_ROOT) return;
        var list = OPEN_ROOT._amcSelectList;
        if (list && !list.hidden) positionList(OPEN_ROOT, list);
      },
      { passive: true }
    );

    window.addEventListener(
      'scroll',
      function () {
        if (!OPEN_ROOT) return;
        var list = OPEN_ROOT._amcSelectList;
        if (list && !list.hidden) positionList(OPEN_ROOT, list);
      },
      true
    );

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.aogen-forms-form') || n.matches('.aogen-forms-block form'))) {
            enhanceRoot(n);
          } else if (n.querySelectorAll) {
            n.querySelectorAll('.aogen-forms-form, .aogen-forms-block form').forEach(enhanceRoot);
            var host = n.closest && n.closest('.aogen-forms-form, .aogen-forms-block form');
            if (host) enhanceRoot(host);
          }
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.AmcSelect = {
    enhance: enhance,
    enhanceRoot: enhanceRoot,
    destroy: destroy,
    scan: scanDocument
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
